import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              密桃视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${scrolled ? 'text-foreground-600' : 'text-background-50/80'}`}>
              <input
                type="text"
                placeholder="搜索视频..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm outline-none transition-all duration-200 w-48 focus:w-64 ${
                  scrolled
                    ? 'bg-background-100 text-foreground-800 placeholder-foreground-400 border border-background-200 focus:border-primary-300'
                    : 'bg-background-50/15 text-background-50 placeholder-background-50/50 border border-background-50/20 focus:bg-background-50/25'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                scrolled
                  ? 'text-foreground-600 hover:text-primary-500'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${cat.icon} text-lg`}></i>
                <span className="text-sm">{cat.name}</span>
              </button>
            ))}
            <div className="border-t border-background-200/70 pt-2 mt-2">
              <Link
                to="/about"
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                <span className="text-sm">关于我们</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}